// src/state/modules/auth.js
export const state = {
    currentUser: (() => {
        const stored = localStorage.getItem('auth.currentUser');
        if (!stored) return null;
        try {
            return JSON.parse(stored);
        } catch (e) {
            console.error('Invalid auth.currentUser in localStorage, clearing:', e);
            localStorage.removeItem('auth.currentUser');
            return null;
        }
    })()
};

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue;
        saveState('auth.currentUser', newValue);
    },
    RESET_STATE(state) {
        state.currentUser = null;
        try {
            localStorage.removeItem('auth.currentUser');
            console.log('RESET_STATE: Cleared auth.currentUser from localStorage');
            // Fallback: localStorage.clear(); // Uncomment for testing
        } catch (e) {
            console.error('Error clearing localStorage:', e);
        }
    }
};

export const getters = {
    loggedIn(state) {
        return !!state.currentUser;
    },
    loggedInUser(state) {
        return state.currentUser;
    }
};

export const actions = {
    setCurrentUser({ commit }, user) {
        commit('SET_CURRENT_USER', user);
    },
    async logout({ commit }) {
        try {
            commit('RESET_STATE');
            console.log('Logout action: currentUser=', null, 'localStorage.auth.currentUser=', localStorage.getItem('auth.currentUser'));
        } catch (e) {
            console.error('Logout action error:', e);
        }
    }
};

function saveState(key, state) {
    try {
        if (state) {
            localStorage.setItem(key, JSON.stringify(state));
        } else {
            localStorage.removeItem(key);
        }
    } catch (e) {
        console.error('Error saving state to localStorage:', e);
    }
}